import { Component } from '@angular/core';
import { FormControl} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

import { CONSTANTS } from '../../../helper/constants';
import { CourseManagerService } from '../../../networking/services/course-manager.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-course-manager-login-dialog',
    imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
],
    templateUrl: './course-manager-login-dialog.component.html',
    styleUrl: './course-manager-login-dialog.component.scss'
})
export class CourseManagerLoginDialogComponent {
  currentView: 'login' | 'reset-request' | 'reset-info' = 'login';
  constants = CONSTANTS
  hide: boolean = true
  loginData = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  })

  resetRequestForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  
  resetConfirmForm = new FormGroup({
    token: new FormControl ('', Validators.required),
    newPassword: new FormControl ('', Validators.required)
  });

  constructor(
    public dialogRef: MatDialogRef<CourseManagerLoginDialogComponent>,
    private courseManagerService: CourseManagerService,
    private router: Router
  ) {}

  onPrimaryClick(): void {
    this.dialogRef.close(true);
  }

  onSecondaryClick(): void {
    this.dialogRef.close(false);
  }

  async submitData(): Promise<void> {
    let data = this.loginData.getRawValue()
    let user: any = await this.courseManagerService.login({
      email: data?.email,
      password: data?.password
    })
    localStorage.setItem('currentUser', btoa(JSON.stringify(user)))
    this.dialogRef.close();
    this.router.navigate(['course-manager/dashboard']);
  }

  switchToForgotPassword() {
    this.currentView = 'reset-request';
  }
  
  switchToResetInfo() {
    this.currentView = 'reset-info';
  }
  
  switchToLogin() {
    this.currentView = 'login';
  }

  async requestResetToken() {
    const email = this.resetRequestForm.value.email;
    if (!email) {
      return;
    }
    await this.courseManagerService.resetPassword(email);
    this.switchToResetInfo();
  }
}
